module.exports = __webpack_public_path__ + "static/media/gold.155588a9.svg";